import { useReviseTransactionMutation } from "../../../services/valuations";

export type ReviseTransactionDetailsRequest = {
    masterAccountId: string
    designationId: string
    productId: string
    custodianId: string
    providerId: string
    wrapperId: string
    assetId: string
    custodianReference: string
    providerReference: string
    transactionDate: string | null
    quantity: number
    value: number
};

const useTransactionDetails = () => {
    const [revise, {}] = useReviseTransactionMutation();

    const reviseTransaction = (request : ReviseTransactionDetailsRequest) => {
        return new Promise((resolve, reject) => {
            return revise({ request }).unwrap()
                .then(
                    (r: any) => resolve(r),
                    (e: any) => reject(e)
                );
        });
    };

    return {
        reviseTransaction
    };
};

export default useTransactionDetails;
